import { ValidatorRuleType } from "@tCooneyBrothers/Common/Utilities/validate";

export const intialErrorFormStateForCreditApp = {
    UserEmail: "",
    bankName: "",
    bankAccount: "",
    bankAddress: "",
    bankPhone: "",
    businessRefCompName1: "",
    businessRefName1: "",
    businessRefAddress1: "",
    businessRefPhone1: "",
    businessRefCompName2: "",
    businessRefName2: "",
    businessRefAddress2: "",
    businessRefPhone2: "",
    receivingHours: "",
    IsTerms: "",
    companyOperationalTime: "",
    principalActivity: "",
    apContact: "",
    ApContactEmail: "",
    invEmailText: "",
    // invFaxText: "",
    BTAddress: "",
    BTCity: "",
    BTCountry: "",
    BTState: "",
    BTZipCode: "",
    BTPhone: "",
    BTEmail: "",
    STAdd1: "",
    STCity: "",
    STCountry: "",
    STState: "",
    STPc: "",
    STPhone: "",
    STEmail: "",
    // IsBankruptText: "",
    // suitFiledText: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const newCustomerCreditValidatorConfig: ValidatorConfigType = {
    UserEmail: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "User Email Address",
        requiredMsg: "Please enter email address",
    },
    BTAddress: {
        required: true,
        minLength: 5,
        label: "Billing Address",
    },
    BTCity: {
        required: true,
        minLength: 2,
        label: "Billing City",
    },
    BTCountry: {
        required: true,
        label: "Billing Country",
        maxLengthMsg: "Please Select Billing Country",
    },
    BTState: {
        required: true,
        label: "Billing State",
        maxLengthMsg: "Please Select Billing State",
    },
    BTZipCode: {
        required: true,
        minLength: 5,
        label: "Billing Zip/Postal Code",
    },
    BTPhone: {
        required: true,
        minLength: 0,
        label: "",
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        maxLength: 12,
        requiredMsg: "Please Enter Phone Number",
    },

    BTEmail: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "Billing Email Address",
        requiredMsg: "Please enter email address",
    },
    STAdd1: {
        required: true,
        minLength: 5,
        label: "Shipping Address",
    },
    STCity: {
        required: true,
        minLength: 2,
        label: "Shipping City",
    },
    STCountry: {
        required: true,
        label: "Shipping Country",
        maxLengthMsg: "Please Select Shipping Country",
    },
    STState: {
        required: true,
        label: "Shipping State",
        maxLengthMsg: "Please Select Shipping State",
    },
    STPc: {
        required: true,
        minLength: 5,
        label: "Shipping Zip/Postal Code",
    },
    STPhone: {
        required: true,
        minLength: 0,
        label: "",
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        maxLength: 12,
        requiredMsg: "Please Enter Phone Number",
    },

    STEmail: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "Shipping Email Address",
        requiredMsg: "Please enter email address",
    },
    bankName: {
        required: true,
        minLength: 2,
        label: "Bank Name",
    },
    bankAccount: {
        required: true,
        minLength: 2,
        label: "Bank Account Number",
    },
    bankAddress: {
        required: true,
        minLength: 2,
        label: "Bank Address",
    },
    bankPhone: {
        required: true,
        maxLength: 12,
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        label: "Bank Phone Number",
    },
    businessRefCompName1: {
        required: true,
        minLength: 2,
        label: "Businesss Reference Company Name",
    },
    businessRefName1: {
        required: true,
        minLength: 2,
        label: "Businesss Reference Name",
    },
    businessRefAddress1: {
        required: true,
        minLength: 2,
        label: "Businesss Reference Address",
    },
    businessRefPhone1: {
        required: true,
        maxLength: 12,
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        label: "Businesss Reference Phone Number",
    },
    businessRefCompName2: {
        required: true,
        minLength: 2,
        label: "Second Businesss Reference Company Name",
    },
    businessRefName2: {
        required: true,
        minLength: 2,
        label: "Second Businesss Reference Name",
    },
    businessRefAddress2: {
        required: true,
        minLength: 2,
        label: "Second Businesss Reference Address",
    },
    businessRefPhone2: {
        required: true,
        maxLength: 12,
        maxLengthMsg:
            "Please enter a valid phone number by entering only numbers. No dashes '-' or Parentheses '(' or ')' or other characters are accepted.",
        label: "Second Businesss Reference Phone Number",
    },
    receivingHours: {
        required: true,
        label: "Receiving Hours",
    },
    IsTerms: {
        required: true,
        label: "Do you have a UPS account # to be used for shipping?",
        requiredMsg: "Please select: Do you have a UPS account # to be used for shipping?",
    },
    companyOperationalTime: {
        required: true,
        label: "'How long has company operated at the above address?'",
        requiredMsg: "Please enter details for 'How long has company operated at the above address?'",
    },
    principalActivity: {
        required: true,
        label: "'Principal activity of the business?'",
        requiredMsg: "Please enter details for 'Principal activity of the business?'",
    },
    apContact: {
        required: true,
        label: "A/P contact",
    },
    ApContactEmail: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "A/P Contact Email Address",
        requiredMsg: "Please enter email address",
    },
    invEmailText: {
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        label: "email address for receiving Invoices/Statements",
        requiredMsg: "Please enter email address for receiving Invoices/Statements",
    },

    invFaxText: {
        required: true,
        minLength: 12,
        label: "Fax Number",
        requiredMsg: "Please enter Fax number for receiving Invoices/Statements",
        maxLengthMsg: "Please Enter Valid Fax Number",
    },
    shippingAccount: {
        required: true,
        label: "Enter UPS or FedEx account number",
        requiredMsg: "Kindly Enter UPS or FedEx account number.",
    },
    pastbuyerName: {
        required: true,
        label: "Enter Name",
        requiredMsg: "Kindly enter a name.",
    },
    companyNameChanged: {
        required: true,
        label: "Enter Name",
        requiredMsg: "Kindly enter former name.",
    },
    suitFiledText: {
        required: true,
        label: "Please specify",
        requiredMsg: "Please specify.",
    },
    IsBankruptText: {
        required: true,
        label: "Please specify",
        requiredMsg: "Please specify.",
    },
};
